module.exports = __webpack_public_path__ + "img/26400.8fb73f72.jpg";